module.exports = __webpack_public_path__ + "static/media/muna_aunt_eye_blink_01.11c2ed77.png";